import type React from 'react';
import { STATUS_FILTERS, STATUS_LABELS, type StatusFilter } from '@/lib/assets';
import { cn } from '@/lib/utils';

interface FilterChipsProps {
  counts: Record<StatusFilter, number>;
  value: StatusFilter;
  onChange: (value: StatusFilter) => void;
}

/** SPEC §11 — status filter chips with live counts. */
export function FilterChips({ counts, value, onChange }: FilterChipsProps): React.JSX.Element {
  return (
    <div className="flex flex-wrap gap-1.5" role="group" aria-label="Filter rows by audio status">
      {STATUS_FILTERS.map((status) => {
        const label = status === 'all' ? 'all' : STATUS_LABELS[status];
        const active = value === status;
        return (
          <button
            key={status}
            type="button"
            aria-pressed={active}
            data-testid={`filter-${status}`}
            onClick={() => onChange(status)}
            className={cn(
              'rounded-full border px-3 py-1 text-xs font-medium transition-colors',
              active
                ? 'border-primary bg-primary text-primary-foreground'
                : 'border-input text-muted-foreground hover:bg-accent hover:text-accent-foreground',
              counts[status] === 0 && !active && 'opacity-60',
            )}
          >
            {label}
            <span className="ml-1.5 tabular-nums">{counts[status]}</span>
          </button>
        );
      })}
    </div>
  );
}
